module.exports = __webpack_public_path__ + "static/img/tip.8ed1358a.svg";